<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.GATEWAY' | translate }}</span>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    @if (flyingGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.FLYING' | translate | uppercase }}</div>
    }

    <div class="gateways picker-list">
      @for (gateway of flyingGateways; track gateway) {
        <div class="gateway picker-item">
          <div class="logo">
            <ng-icon name="heroSignal" size="18"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addGateway(gateway)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

    @if (missionSkidsGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.SKID' | translate | uppercase }}</div>
    }

    <div class="gateways picker-list">
      @for (gateway of missionSkidsGateways; track gateway) {
        <div class="gateway picker-item">
          <div class="logo">
            <ng-icon name="heroSignal" size="18"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addGateway(gateway)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

    @if (missionAnalyzersGateways.length > 0) {
      <div class="title">{{ 'GATEWAY.ANALYZER' | translate | uppercase }}</div>
    }

    <div class="gateways picker-list">
      @for (gateway of missionAnalyzersGateways; track gateway) {
        <div class="gateway picker-item">
          <div class="logo">
            <ng-icon name="heroSignal" size="18"/>
            <a>{{ gateway.gatewayId }}</a>
          </div>
          <div class="info">
            <a>{{ 'GATEWAY.NAME' | translate }}: {{ gateway.gatewayName }}</a>
            <a>{{ 'GATEWAY.MODEL' | translate }}: {{ gateway.gatewaymodelname }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addGateway(gateway)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>